import { LoginType } from "../constants/enum";
import { User } from "./user";

export type accessToken = {
  tokenType: string;
  accessToken: string;
};

export enum LoginSite {
  STUDENT = "STUDENT",
  TUTOR = "TUTOR",
}

// type refreshToken = {
//   tokenType: string;
//   refreshToken: string;
// };

export type SignInResponse = {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  user: User;
  authorizationUrl: string
  state: string
  message: string
};

export type SignInRequest = {
  username?: string;
  password?: string;
  createdType: LoginType;
  site?: LoginSite
  website?: string
};

export interface ExchangeTokenRequest {
  code: string
}

export interface ExchangeTokenResponse {
  accessToken: string
  refreshToken: string
  tokenType: string
  user: User
  accountType: LoginType
}

export type RegisterRequest = {
  username: string;
  full_name: string;
  email: string;
  password: string;
  confirmPassword: string;
  createdType: LoginType;
  userRole: "STUDENT";
};

export type RequestResetPasswordRequest = {
  email: string;
  role: "STUDENT";
};

export type ResetPasswordRequest = {
  token: string;
  newPassword: string;
};

export type ChangeEmailPasswordRequest = {
  new_email?: string;
  new_password?: string;
  old_password?: string;
}
